import React, { useEffect } from 'react'
import {
    Box,
    Button,
    Grid,
} from '@material-ui/core'
import { businessUnits } from '../../../../store/slices'
import { useAppDispatch, useAppSelector } from '../../../../store'
import { useHistory } from 'react-router-dom'
import { unwrapResult } from '@reduxjs/toolkit'
import { SideBar } from '../../../../components/side-bar'
import { Content } from '../../../../components/content'
import { navLinksOrganization } from '../../../../services'
import { Field, Form, Formik } from 'formik'
import { BusinessUnitUpdateProps } from '../../../../store/types'
import { CheckboxWithLabel, TextField } from 'formik-material-ui'

interface BusinessUnitEditPageProps {
    match: {
        params: {
            id: string
        }
    }
}

export function BusinessUnitEditPage(props: BusinessUnitEditPageProps): JSX.Element {
    useEffect(() => {
        dispatch(businessUnits.actions.fetch())
    }, [])

    const dispatch = useAppDispatch()
    const history = useHistory()
    const bu = useAppSelector((state) => businessUnits.selectors.selectById(state, props.match.params.id))
    const initialValues: BusinessUnitUpdateProps = bu ? bu :  { id: '', iri: '', name: '', active:  false}

    return (
        <Formik
            initialValues={initialValues}
            enableReinitialize
            onSubmit={(values, { setSubmitting }) => {
                dispatch(businessUnits.actions.update(values))
                    .then(unwrapResult)
                    .then(() => {
                        history.goBack()
                    })
                setSubmitting(false)
            }}
        >
            {({ submitForm }) => (
                <Form>
                    <Box display="flex">
                        <SideBar navLinks={navLinksOrganization}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={submitForm}
                            >
                                Сохранить
                            </Button>
                        </SideBar>
                        <Content loading={false} notFoundContent={false} title={'Создание БЮ'}>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Field
                                        component={TextField}
                                        label="Название"
                                        name="name"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Field
                                        component={CheckboxWithLabel}
                                        Label={{ label: 'Активна' }}
                                        name="active"
                                        type="checkbox"
                                    />
                                </Grid>
                            </Grid>
                        </Content>
                    </Box>
                </Form>
            )}
        </Formik>
    )
}